import React from "react";
import {
  CustomText,
  FallBack,
  CustomTextInput,
  PrimaryCta,
  Popup,
  PriceModal,
} from "../components";
import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import Utils from "../common/utils";
import Core from "../common/clientSdk";
import { useDispatch, useSelector } from "react-redux";
// TODO: Uncomment and fix the path once the features directory is created
// import { useToast } from "features/toastContainer";
const useToast = () => ({ showToast: () => {} }); // Temporary mock

function PriceToCollectionInfluencer({
  closePriceModal,
  setCollectionInfluencerList,
  collectionInfluencerList,
  collectionId,
  influencerId,
  priceType,
}) {
  const [price, setPrice] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");
  const showToast = useToast();
  var redux_selector = useSelector((state) => {
    return {
      UserData: state.BrandUserDataReducer,
      Auth: state.BrandUserAuthReducer,
    };
  });

  const { UserData = {} } = redux_selector;
  const { brand_deep_data = {} } = UserData;
  const { user_data = {} } = UserData;
  const { brand_data = {} } = brand_deep_data;

  console.log("collectionId of campaign", collectionId);
  function addPriceToCollectionInfluencer() {
    if (!price || price < 1) {
      toast.error("Please Add Price");
      return false;
    }

    console.log("price before conversion", price);

    const params = {
      collection_id: collectionId,
      influencer_id: influencerId,
    };

    if (priceType === "price" && price>0) {
      params.price = price
    } else if (priceType === "internal_price" && price>0) {
      params.internal_price = price
    } 

    console.log("Sending params:", params);
    Core.addPriceToCollectionInfluencerAdmin(
      addPriceToCollectionInfluencerSuccess,
      addPriceToCollectionInfluencerFail,
      (status) => setLoading(status),
      params
    );
  }

  function addPriceToCollectionInfluencerSuccess(response) {
    console.log("Price update response:", response);

    // Update the list instantly with the new price
    setCollectionInfluencerList((prevList) => {
      // Ensure prevList is an array
      const currentList = Array.isArray(prevList) ? prevList : [];
      
      return currentList.map((influencer) => {
        if (influencer?.influencer_data?.influencer_id === influencerId) {
          return {
            ...influencer,
            influencer_data: {
              ...influencer?.influencer_data,
              ...(priceType == "price" && price && {
                client_price: price,
              }),
              ...(priceType == "internal_price" && price && {
                internal_price: price,
              }),
            },
          };
        }
        return influencer;
      });
    });

    toast.success(
      `${priceType === "price" ? "Client" : "Internal"} price updated successfully`
    );
    closePriceModal();
  }

  function addPriceToCollectionInfluencerFail(errorList) {
    toast.error(errorList);
  }

  function handlePriceChange(e) {
    const newValue = e.target.value;
    if (newValue === "" || /^[0-9\b]+$/.test(newValue)) {
      setPrice(newValue);
      setError("");
    } else {
      setError("Only numeric values are allowed.");
    }
  }

  function renderAddPrice() {
    return (
      <>
        <PriceModal
          isOpen={true}
          onClose={() => closePriceModal()}
          header={"Price"}
          subheading={priceType == "price" ? "Client Cost" : "Influencer Cost"}
          textinput={
            <>
              <div>
                <CustomTextInput
                  value={price}
                  onChange={handlePriceChange}
                  onWheel={(e) => e.target.blur()}
                  placeHolder={"eg. 1000"}
                  type="number"
                />
                {error && <p style={{ color: "red", fontSize: 12 }}>{error}</p>}
              </div>
            </>
          }
          confirmButtonText={"Update"}
          cancelButtonText="Cancel"
          onConfirm={() => addPriceToCollectionInfluencer()}
          onCancel={() => closePriceModal()}
          isLoading={loading}
        />
      </>
    );
  }

  return <>{renderAddPrice()}</>;
}

export default PriceToCollectionInfluencer;
